import { ChangeEvent } from 'react'
import { CircularProgress } from '@mui/material'

import {
  ChartImage,
  ChartImageWrapper,
  ChartLabel,
  ChartLabelText,
  ChartSelectorButton,
  Container,
  Input,
  LoadingOverlay
} from './ChartSelector.styles'

interface ChartSelectorProps {
  id: string
  label: string
  imageSrc: string
  isActive: boolean
  size?: 'sm' | 'md'
  // Clamps the label to 2 lines with an ellipsis (for long, free-form names like
  // user charts). Off by default so the short fixed labels keep their layout.
  clampLabel?: boolean
  // Shows a spinner over the image and blocks clicks while the chart is being
  // fetched/activated (used by user charts, whose tiles may download on demand).
  isLoading?: boolean
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
}

function ChartSelector(props: ChartSelectorProps) {
  const { label, imageSrc, id, isActive, size, clampLabel, isLoading, onChange } = props

  return (
    <Container size={size}>
      <Input type="checkbox" id={id} checked={isActive} disabled={isLoading} onChange={(e) => onChange?.(e)} />
      <ChartSelectorButton htmlFor={id} isActive={isActive} size={size}>
        <ChartImageWrapper>
          <ChartImage src={imageSrc} size={size} />
          {isLoading && (
            <LoadingOverlay>
              <CircularProgress size={20} color="inherit" />
            </LoadingOverlay>
          )}
        </ChartImageWrapper>
        <ChartLabel size={size}>{clampLabel ? <ChartLabelText>{label}</ChartLabelText> : label}</ChartLabel>
      </ChartSelectorButton>
    </Container>
  )
}

export { ChartSelector }
